<ba-card>
  <div class="row">
    <div class="col-md-12" style="padding-right: 5px; padding-left: 0px">
      <div class="row">
        <h4 style="text-align: center; display: block; margin-bottom: 5px">
          {{ _transactionService.pageHeading }} Entry
        </h4>
      </div>
      <div style="height: 325px; overflow: scroll">
        <table style="margin-bottom: 5px; font-size: 13px; width: 100%">
          <thead>
            <tr
              style="
                border-bottom: 2px solid #e6e6e6;
                border-top: 2px solid #e6e6e6;
              "
            >
              <th style="width: 7%">SNo.</th>
              <th style="width: 50%">
                {{ _transactionService.TableAcHeader }}
              </th>
              <th
                style="width: 16%"
                *ngIf="voucherType == 17 || voucherType == 15"
              >
                Dr Amount
              </th>
              <th
                style="width: 16%"
                *ngIf="voucherType == 18 || voucherType == 16"
              >
                Cr Amount
              </th>
              <th style="width: 45%">Cost Center</th>
              <th style="width: 27%" *ngIf="viewMode == false"></th>
            </tr>
          </thead>
          <tbody
            *ngFor="let t of TrnTranList; let i = index"
            (click)="rowClick(i)"
          >
            <tr>
              <td style="line-height: 21px; text-align: center">
                <div
                  *ngIf="t.AccountItem.HASSUBLEDGER == 1"
                  style="display: inline-block"
                >
                  *
                </div>
                {{ i + 1 }}.
              </td>
              <td>
                <div *ngIf="t.ROWMODE == 'new' || t.ROWMODE == 'edit'">
                  <!--<md-autocomplete #auto="mdAutocomplete">
                                <md-option *ngFor="let option of accountlistArray" [value]="option.ACNAME">
                                    {{ option.ACNAME }}
                                </md-option>
                            </md-autocomplete>-->
                  <input
                    ngui-auto-complete
                    tabindex="1"
                    [focus]="addFocus"
                    [source]="accountListObservable$.bind(this)"
                    [(ngModel)]="t.acitem"
                    list-formatter="ACNAME"
                    (ngModelChange)="AutoSelectAcnameChange($event, i)"
                    style="padding-left: 4px; width: 100%"
                  />

                  <!--<select (ngModelChange)="trnAccountChange($event.HASSUBLEDGER,i)" [(ngModel)]="t.AccountItem" [focus]="acNameFocused" style="padding-left:4px;width:270px">
                                                    <option *ngFor="let acList of trnaccountList |async " [ngValue]="acList">
                                                        {{acList.ACNAME}}
                                                    </option>
                                            </select>-->
                </div>

                <div *ngIf="t.ROWMODE == 'save'" style="line-height: 21px">
                  {{ t.AccountItem.ACNAME }}
                </div>
              </td>
              <td>
                <div *ngIf="t.ROWMODE == 'new' || t.ROWMODE == 'edit'">
                  <div *ngIf="voucherType == 17 || voucherType == 15">
                    <input
                      tabindex="2"
                      [disabled]="t.acitem == null || t.acitem.ACID == null"
                      style="width: 100%; padding-left: 4px"
                      type="number"
                      [(ngModel)]="t.DRAMNT"
                      (ngModelChange)="TrnTranDrAmtChange($event)"
                    />
                  </div>
                  <div *ngIf="voucherType == 16 || voucherType == 18">
                    <input
                      tabindex="2"
                      [disabled]="t.acitem == null || t.acitem.ACID == null"
                      style="width: 100%; padding-left: 4px"
                      type="number"
                      [(ngModel)]="t.CRAMNT"
                      (ngModelChange)="TrnTranCrAmtChange($event)"
                    />
                  </div>
                </div>

                <div *ngIf="t.ROWMODE == 'save'">
                  <td
                    *ngIf="voucherType == 17 || voucherType == 15"
                    style="width: 90px"
                    style="line-height: 21px"
                  >
                    {{ t.DRAMNT }}
                  </td>
                  <td
                    *ngIf="voucherType == 16 || voucherType == 18"
                    style="width: 90px"
                    style="line-height: 21px"
                  >
                    {{ t.CRAMNT }}
                  </td>
                </div>
              </td>
              <td>
                <div *ngIf="t.ROWMODE == 'new' || t.ROWMODE == 'edit'">
                  <select
                    tabindex="3"
                    style="width: 100%; padding-left: 4px"
                    [(ngModel)]="t.CostCenter"
                  >
                    <option hidden></option>
                    <option
                      *ngFor="
                        let cc of this.masterService.costCenterList$ | async
                      "
                      [ngValue]="cc.CostCenterName"
                    >
                      {{ cc.CostCenterName }}
                    </option>
                  </select>
                </div>

                <div *ngIf="t.ROWMODE == 'save'">
                  <div style="width: 170px; line-height: 21px">
                    {{ t.CostCenter }}
                  </div>
                </div>
              </td>
              <td style="display: flex" *ngIf="viewMode == false">
                <!--<button style="margin-top:4.5px;" [disabled]="t.AccountItem==null ||t.AccountItem.ACID==null|| ((voucherType==17 || voucherType==15) && t.DRAMNT==null)||((voucherType==17 || voucherType==15) && t.DRAMNT<=0) ||((voucherType==16 || voucherType==18) && t.CRAMNT==null)||((voucherType==16 || voucherType==18) && t.CRAMNT<=0)" *ngIf="t.ROWMODE!='save'"  (click)="TrnTranRowOk(i)" class="glyphicon glyphicon-ok"></button>                                         -->
                <button
                  *ngIf="t.ROWMODE == 'save'"
                  (click)="editRow(i)"
                  class="glyphicon glyphicon-edit"
                ></button>
                <button
                  *ngIf="t.ROWMODE == 'save'"
                  style="margin-left: 3px"
                  (click)="clearRow(i)"
                  class="glyphicon glyphicon-remove"
                ></button>
                <!--<button *ngIf="t.ROWMODE!='save'" style="margin-top:4.5px; margin-left:3px;" (click)="clearRow(i)" class="glyphicon glyphicon-remove"></button>-->
              </td>
            </tr>
            <tr>
              <td></td>
              <td colspan="4" style="line-height: 22px">
                <div
                  *ngIf="t.ROWMODE == 'new' || t.ROWMODE == 'edit'"
                  style="display: inline-block"
                >
                  <!--<div *ngIf="t.ROWMODE=='new' || t.ROWMODE=='edit'">-->
                  <input
                    tabindex="4"
                    placeholder="Narration"
                    style="width: 416px; padding-left: 4px; margin-bottom: 4px"
                    type="text"
                    [(ngModel)]="t.NARATION"
                  />
                </div>
                <div
                  *ngIf="
                    t.ROWMODE == 'save' &&
                    t.NARATION != null &&
                    t.NARATION != ''
                  "
                >
                  <div style="width: 423px; line-height: 21px">
                    ( {{ t.NARATION }} )
                  </div>
                </div>
                <div
                  style="display: inline-block"
                  *ngIf="viewMode == false && t.ROWMODE != 'save'"
                >
                  <button
                    tabindex="5"
                    style="margin-top: 1.5px; margin-left: 3px"
                    [disabled]="
                      t.AccountItem == null ||
                      t.AccountItem.ACID == null ||
                      ((voucherType == 17 || voucherType == 15) &&
                        t.DRAMNT == null) ||
                      ((voucherType == 17 || voucherType == 15) &&
                        t.DRAMNT <= 0) ||
                      ((voucherType == 16 || voucherType == 18) &&
                        t.CRAMNT == null) ||
                      ((voucherType == 16 || voucherType == 18) &&
                        t.CRAMNT <= 0)
                    "
                    (click)="TrnTranRowOk(i)"
                    class="glyphicon glyphicon-ok"
                  ></button>
                  <button
                    tabindex="6"
                    style="margin-top: 1.5px"
                    (click)="clearRow(i)"
                    class="glyphicon glyphicon-remove"
                  ></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="form-inline" style="margin-top: 5px">
        <label style="width: 250px; text-align: right">Total:</label
        ><input
          value="{{ trntranTotal }}"
          disabled
          type="text"
          style="padding-left: 4px; margin-left: 3px; width: 120px"
        />
      </div>
    </div>

    <div *ngIf="showWholeSubLedger">
      <div
        *ngIf="hideSubledger == false"
        class="col-md-5"
        style="padding-left: 0px; padding-left: 5px"
      >
        <label style="text-align: center; display: block; font-size: 18px"
          >Sub-Ledger Entry</label
        >

        <div style="height: 325px; overflow: scroll">
          <table class="table" style="margin-bottom: 5px; font-size: 12.5px">
            <thead>
              <tr
                style="
                  border-bottom: 2px solid #e6e6e6;
                  border-top: 2px solid #e6e6e6;
                "
              >
                <th>SNo.</th>
                <th>Subledger Name</th>
                <th *ngIf="voucherType == 16 || voucherType == 18">
                  Dr Amount
                </th>
                <th *ngIf="voucherType == 17 || voucherType == 15">
                  Cr Amount
                </th>
                <th *ngIf="viewMode == false"></th>
              </tr>
            </thead>
            <tbody
              *ngFor="let sl of subledgers; let i = index"
              style="border-top: 0px"
            >
              <tr>
                <td style="line-height: 21px">{{ i + 1 }}.</td>
                <td>
                  <div *ngIf="sl.ROWMODE == 'new' || sl.ROWMODE == 'edit'">
                    <select [(ngModel)]="sl.SubledgerItem" style="width: 235px">
                      <option
                        *ngFor="let sublist of subledgerDropDownList"
                        [ngValue]="sublist"
                      >
                        {{ sublist.ACNAME }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="sl.ROWMODE == 'save'" style="line-height: 21px">
                    {{ sl.SubledgerItem.ACNAME }}
                  </div>
                </td>

                <td>
                  <div *ngIf="sl.ROWMODE == 'new' || sl.ROWMODE == 'edit'">
                    <div
                      *ngIf="voucherType == 16 || voucherType == 18"
                      style="width: 90px"
                    >
                      <input
                        [disabled]="
                          sl.SubledgerItem == null ||
                          sl.SubledgerItem.ACNAME == null
                        "
                        style="width: 90px"
                        type="number"
                        [(ngModel)]="sl.DRAMNT"
                        (keyup)="subLedgerDrAmtChanges()"
                      />
                    </div>
                    <div *ngIf="voucherType == 17 || voucherType == 15">
                      <input
                        [disabled]="
                          sl.SubledgerItem == null ||
                          sl.SubledgerItem.ACNAME == null
                        "
                        style="width: 90px"
                        type="number"
                        [(ngModel)]="sl.CRAMNT"
                        (keyup)="subLedgerCrAmtChanges()"
                      />
                    </div>
                  </div>
                  <div *ngIf="sl.ROWMODE == 'save'">
                    <div
                      *ngIf="voucherType == 16 || voucherType == 18"
                      style="width: 90px; line-height: 21px"
                    >
                      {{ sl.DRAMNT }}
                    </div>
                    <div
                      *ngIf="voucherType == 17 || voucherType == 15"
                      style="width: 90px; line-height: 21px"
                    >
                      {{ sl.CRAMNT }}
                    </div>
                  </div>
                </td>
                <td style="display: flex" *ngIf="viewMode == false">
                  <!--<button style="margin-top:4.5px;" [disabled]="sl.SubledgerItem==null ||sl.SubledgerItem.ACNAME==null||((voucherType==17 || voucherType==15) && sl.CRAMNT==null)||((voucherType==17 || voucherType==15) && sl.CRAMNT<=0) ||((voucherType==16 || voucherType==18) && sl.DRAMNT==null)||((voucherType==16 || voucherType==18) && sl.DRAMNT<=0)" *ngIf="sl.ROWMODE!='save'"  (click)="SubLedgerRowOk(i)"  class="glyphicon glyphicon-ok"></button>                                         -->
                  <button
                    *ngIf="sl.ROWMODE == 'save'"
                    (click)="editSubledgerRow(i)"
                    class="glyphicon glyphicon-edit"
                  ></button>
                  <button
                    *ngIf="sl.ROWMODE == 'save'"
                    style="margin-left: 3px"
                    (click)="clearSubLedgerRow(i)"
                    class="glyphicon glyphicon-remove"
                  ></button>
                  <!--<button *ngIf="sl.ROWMODE!='save'" style="margin-top:4.5px; margin-left:3px;" (click)="clearSubLedgerRow(i)" class="glyphicon glyphicon-remove"></button>-->
                </td>
              </tr>
              <tr>
                <td></td>
                <td colspan="3" style="line-height: 22px">
                  <div
                    *ngIf="sl.ROWMODE == 'new' || sl.ROWMODE == 'edit'"
                    style="display: inline-block"
                  >
                    <!--<div *ngIf="sl.ROWMODE=='new' || sl.ROWMODE=='edit'">-->
                    <input
                      placeholder="Narration"
                      style="
                        width: 281px;
                        padding-left: 4px;
                        margin-bottom: 4px;
                      "
                      type="text"
                      [(ngModel)]="sl.NARATION"
                    />
                  </div>
                  <div
                    *ngIf="
                      sl.ROWMODE == 'save' &&
                      sl.NARATION != null &&
                      sl.NARATION != ''
                    "
                  >
                    <div style="width: 281px; line-height: 21px">
                      ( {{ sl.NARATION }} )
                    </div>
                  </div>
                  <div
                    style="display: inline-block"
                    *ngIf="viewMode == false && sl.ROWMODE != 'save'"
                  >
                    <button
                      style="margin-top: 1.5px; margin-left: 3px"
                      [disabled]="
                        sl.SubledgerItem == null ||
                        sl.SubledgerItem.ACNAME == null ||
                        ((voucherType == 17 || voucherType == 15) &&
                          sl.CRAMNT == null) ||
                        ((voucherType == 17 || voucherType == 15) &&
                          sl.CRAMNT <= 0) ||
                        ((voucherType == 16 || voucherType == 18) &&
                          sl.DRAMNT == null) ||
                        ((voucherType == 16 || voucherType == 18) &&
                          sl.DRAMNT <= 0)
                      "
                      *ngIf="sl.ROWMODE != 'save'"
                      (click)="SubLedgerRowOk(i)"
                      class="glyphicon glyphicon-ok"
                    ></button>
                    <button
                      *ngIf="sl.ROWMODE != 'save'"
                      style="margin-top: 1.5px"
                      (click)="clearSubLedgerRow(i)"
                      class="glyphicon glyphicon-remove"
                    ></button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="form-inline" style="margin-top: 5px">
          <label style="text-align: right; width: 270px"
            >SubLedger Total:</label
          >
          <input
            disabled
            type="text"
            value="{{ subLedgerTotal }}"
            style="padding-left: 4px; width: 100px"
          />
        </div>
      </div>

      <div
        *ngIf="hideSubledgerList == false"
        class="col-md-5"
        style="padding-left: 5px; padding-right: 0px"
        id="sub-ledger"
      >
        <label style="text-align: center; display: block; font-size: 18px"
          >Sub-Ledger List</label
        >
        <div style="display: block; height: 325px; overflow: scroll">
          <table class="table" style="margin-bottom: 5px; font-size: 12.5px">
            <thead>
              <tr
                style="
                  border-bottom: 2px solid #e6e6e6;
                  border-top: 2px solid #e6e6e6;
                "
              >
                <th>SNo.</th>
                <th>Subledger Name</th>
                <th *ngIf="voucherType == 16 || voucherType == 18">
                  Dr Amount
                </th>
                <th *ngIf="voucherType == 17 || voucherType == 15">
                  Cr Amount
                </th>
              </tr>
            </thead>
            <tbody
              *ngFor="let tList of TrnTranList; let i = index"
              style="border: 0px"
            >
              <tr *ngIf="tList.AccountItem.HASSUBLEDGER == 1">
                <td
                  *ngIf="
                    tList.AccountItem.ACCODE != null ||
                    tList.AccountItem.ACNAME != null
                  "
                >
                  <strong></strong>
                </td>
                <td
                  style="border-bottom: 2px solid #e6e6e6; line-height: 21px"
                  *ngIf="
                    tList.AccountItem.ACCODE != null ||
                    tList.AccountItem.ACNAME != null
                  "
                >
                  <strong>{{ tList.AccountItem.ACNAME }}:</strong>
                </td>
                <td
                  style="border-bottom: 2px solid #e6e6e6; line-height: 21px"
                ></td>
              </tr>

              <tr
                *ngFor="
                  let sList of TrnTranList[i].SubledgerTranList;
                  let j = index
                "
              >
                <td
                  *ngIf="
                    sList.SubledgerItem != null &&
                    sList.SubledgerItem.ACNAME != null
                  "
                  style="line-height: 21px"
                >
                  {{ j + 1 }}.
                </td>
                <td
                  style="line-height: 21px"
                  *ngIf="sList.SubledgerItem != null"
                >
                  {{ sList.SubledgerItem.ACNAME }}
                </td>
                <td
                  *ngIf="
                    (voucherType == 16 || voucherType == 18) &&
                    sList.SubledgerItem != null
                  "
                  style="line-height: 21px"
                >
                  {{ sList.DRAMNT }}
                </td>
                <td
                  *ngIf="
                    (voucherType == 17 || voucherType == 15) &&
                    sList.SubledgerItem != null
                  "
                  style="line-height: 21px"
                >
                  {{ sList.CRAMNT }}
                </td>
              </tr>
              <!--<tr *ngFor="let sList of TrnTranList[i].SubledgerTranList;let j=index">
                            <td></td>
                            <td colspan="3" style="line-height: 22px;">
                                <div *ngIf="sList.ROWMODE=='save' && sList.NARATION!=null && sList.NARATION!='' && sList.SubledgerItem != null">
                                    <div style="width:281px; line-height:21px;">( {{sList.NARATION}} )</div>
                                </div>
                            </td>
                        </tr>-->
            </tbody>
          </table>
        </div>

        <div class="form-inline" style="margin-top: 5px">
          <label style="text-align: right; width: 270px"
            >SubLedger Total:</label
          >
          <input
            disabled
            type="text"
            value="{{ subLedgerTotal }}"
            style="padding-left: 4px; width: 100px"
          />
        </div>
      </div>

      <div
        *ngIf="showHelp == true"
        class="col-md-5"
        style="padding-left: 5px; padding-right: 0px"
        id="help"
      >
        <label style="text-align: center; display: block; font-size: 18px"
          >Help</label
        >
        <table
          class="table"
          style="margin-bottom: 5px; height: 325px; overflow: scroll"
        >
          <h5><strong>What is Lorem Ipsum?</strong></h5>
          <p>
            <strong>Lorem Ipsum</strong> is simply dummy text of the printing
            and typesetting industry. Lorem Ipsum has been the industry's
            standard dummy text ever since the 1500s, when an unknown printer
            took a galley of type and scrambled it to make a type specimen book.
            It has survived not only five centuries, but also the leap into
            electronic typesetting, remaining essentially unchanged. It was
            popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, and more recently with desktop
            publishing software like Aldus PageMaker including versions of Lorem
            Ipsum
          </p>
        </table>
      </div>
    </div>
  </div>
</ba-card>
